import { Component, computed, input, Input, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISystemIcons } from './system-icons';
import { v4 as uuid } from 'uuid';

@Component({
    selector: 'lib-system-icons',
    templateUrl: './system-icons.component.html',
    imports: [
      CommonModule
    ]
})
export class SystemIconsComponent {
  @Input() iconName: ISystemIcons['iconName'] = null;
  public readonly iconFill = input<string>();
  public readonly iconStroke = input<string>();
  public readonly iconScale = input<number>(1);
  /** Height in pixels. Use with iconWidth to control logo/icon dimensions. */
  public readonly iconHeight = input<number>();
  /** Width in pixels. Use with iconHeight to control logo/icon dimensions. */
  public readonly iconWidth = input<number>();
  public readonly uuid = uuid();

  @HostBinding('style.transform') get hostTransform(): string | null {
    const s = this.iconScale();
    return s != null && s !== 1 ? `scale(${s})` : null;
  }

  @HostBinding('style.transform-origin') hostTransformOrigin = 'center center';

  @HostBinding('style.height') get hostHeight(): string | null {
    const h = this.iconHeight();
    return h != null ? `${h}px` : null;
  }

  @HostBinding('style.width') get hostWidth(): string | null {
    const w = this.iconWidth();
    return w != null ? `${w}px` : null;
  }

  /**
   * An svg left with only a viewBox lays out as a 0x0 flex item in WebKit, so a caller that
   * sizes the host instead of passing dimensions gets `100%` on both sides. One dimension is
   * already enough for WebKit, so the other side stays absent and derives from the ratio.
   */
  public readonly svgWidth = computed<number | string | null>(() =>
    this.iconWidth() ?? (this.iconHeight() == null ? '100%' : null)
  );

  /** Height counterpart of {@link svgWidth}. */
  public readonly svgHeight = computed<number | string | null>(() =>
    this.iconHeight() ?? (this.iconWidth() == null ? '100%' : null)
  );

  /** Computed width for logo-actuar-text when only iconHeight is set (80:22 ratio). */
  get logoActuarTextWidth(): number {
    const h = this.iconHeight();
    return h != null ? Math.round((80 / 22) * h) : 80;
  }

  get logoActuarTextHeight(): number {
    return this.iconHeight() ?? 22;
  }
}
